import type { RootState } from 'src/app/store/types';
import { bambiApi } from 'src/common/external/bambi-api/bambiApi';

// for selectors and thunks, which can't call useFeature; reads the same cache entry
const selectFeatureFlags = bambiApi.endpoints.flagsFeatureValuesWebList.select(
  {}
);

export const selectIsSplitDispatchEnabled = (state: RootState): boolean =>
  !!selectFeatureFlags(state).data?.results.find(
    (flag) => flag.feature_name === 'split dispatch endpoints'
  )?.feature_is_on;
